let e;
typeof window < "u" ? e = window : typeof globalThis < "u" ? e = globalThis : typeof self < "u" ? e = self : e = {};
const f = e;
export {
  f as default
};
